export enum SchoolTerms {
  All = 0,
  /// <summary>
  /// 一学期
  /// </summary>
  FirstSemester = 10,
  /// <summary>
  /// 一学期中間
  /// </summary>
  FirstMiddleSemester = 15,
  /// <summary>
  /// 一学期期末
  /// </summary>
  FirstEndSemester = 19,
  /// <summary>
  /// 二学期
  /// </summary>
  SecondSemester = 20,
  /// <summary>
  /// 二学期中間
  /// </summary>
  SecondMiddleSemester = 25,
  /// <summary>
  /// 二学期期末
  /// </summary>
  SecondEndSemester = 29,
  /// <summary>
  /// 三学期
  /// </summary>
  ThirdSemester = 30,
  /// <summary>
  /// 三学期中間
  /// </summary>
  ThirdMiddleSemester = 35,
  /// <summary>
  /// 三学期期末
  /// </summary>
  ThirdEndSemester = 39,
  /// <summary>
  /// 前期
  /// </summary>
  PreviousTerm = 40,
  /// <summary>
  /// 前期中間
  /// </summary>
  PreviousMiddleTerm = 45,
  /// <summary>
  /// 前期期末
  /// </summary>
  PreviousEndTerm = 49,
  /// <summary>
  /// 後期
  /// </summary>
  LateStage = 50,
  /// <summary>
  /// 後期中間
  /// </summary>
  LateMiddleStage = 55,
  /// <summary>
  /// 後期期末
  /// </summary>
  LateEndStage = 59,
}

export function getSchoolTermName(value: SchoolTerms): string {
  switch (value) {
    case SchoolTerms.All: return 'すべて';
    case SchoolTerms.FirstSemester: return '１学期';
    case SchoolTerms.FirstMiddleSemester: return '１学期　中間';
    case SchoolTerms.FirstEndSemester: return '１学期　期末';
    case SchoolTerms.SecondSemester: return '２学期';
    case SchoolTerms.SecondMiddleSemester: return '２学期　中間';
    case SchoolTerms.SecondEndSemester: return '２学期　期末';
    case SchoolTerms.ThirdSemester: return '３学期';
    case SchoolTerms.ThirdMiddleSemester: return '３学期　中間';
    case SchoolTerms.ThirdEndSemester: return '３学期　期末';
    case SchoolTerms.PreviousTerm: return '前期';
    case SchoolTerms.PreviousMiddleTerm: return '前期　中間';
    case SchoolTerms.PreviousEndTerm: return '前期　期末';
    case SchoolTerms.LateStage: return '後期';
    case SchoolTerms.LateMiddleStage: return '後期　中間';
    case SchoolTerms.LateEndStage: return '後期　期末';
  }
}

export function getSchoolTermSemesterItems(isAll: boolean) {
  return [
    SchoolTerms.All,
    SchoolTerms.FirstSemester,
    SchoolTerms.SecondSemester,
    SchoolTerms.ThirdSemester,
    SchoolTerms.PreviousTerm,
    SchoolTerms.LateStage,
  ].filter((id) => isAll || id !== SchoolTerms.All)
    .map((id) => ({ id, name: getSchoolTermName(id) }));
}

export function getSchoolTermTestSemesterItems(isAll: boolean) {
  return [
    SchoolTerms.All,
    SchoolTerms.FirstMiddleSemester,
    SchoolTerms.FirstEndSemester,
    SchoolTerms.SecondMiddleSemester,
    SchoolTerms.SecondEndSemester,
    SchoolTerms.ThirdMiddleSemester,
    SchoolTerms.ThirdEndSemester,
    SchoolTerms.PreviousMiddleTerm,
    SchoolTerms.PreviousEndTerm,
    SchoolTerms.LateMiddleStage,
    SchoolTerms.LateEndStage,
  ].filter((id) => isAll || id !== SchoolTerms.All)
    .map((id) => ({ id, name: getSchoolTermName(id) }));
}
